var map = {
	"./ar.json": 765,
	"./en.json": 766,
	"./localise_stf/ar.json": 363,
	"./localise_stf/en.json": 364,
	"./menu_ar.json": 365,
	"./menu_en.json": 366,
	"./menu_kw_ar.json": 280,
	"./menu_kw_en.json": 281
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 764;